module.exports = __webpack_public_path__ + "static/3-65ad9120173400e84b76e686af66ad86.gif";